import { Box, CircularProgress } from "@mui/material";
import React from "react";
import { useCaptureExtractionEquipment } from "../../../hooks/Capture";
import ExtractionEquipments from "../ExtractionEquipment/ExtractionEquipments";

interface ExtractionEquipmentTabProps {
  captureId: string;
  handleError: (error: any) => void;
  canEdit: boolean;
}

const ExtractionEquipmentTab: React.FC<ExtractionEquipmentTabProps> = ({ captureId, handleError, canEdit }) => {
  const { extractionEquipmentsData, isPending, createExtractionEquipment, updateExtractionEquipment, deleteExtractionEquipment } = useCaptureExtractionEquipment(captureId);

  if (isPending && extractionEquipmentsData.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ExtractionEquipments
      extractionEquipmentsData={extractionEquipmentsData}
      canEdit={canEdit}
      onCreate={async (values) => {
        await createExtractionEquipment(values).catch(handleError);
      }}
      onUpdate={async (id, values) => {
        await updateExtractionEquipment({ equipmentId: id, values }).catch(handleError);
      }}
      onDelete={async (id) => {
        await deleteExtractionEquipment(id).catch(handleError);
      }}
    />
  );
};

export default ExtractionEquipmentTab;
